import * as React from 'react';
import Avatar from '@mui/joy/Avatar';
import Chip from '@mui/joy/Chip';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import ButtonGroup from '@mui/joy/ButtonGroup';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import CardOverflow from '@mui/joy/CardOverflow';
import CardActions from '@mui/joy/CardActions';
import IconButton from '@mui/joy/IconButton';
import Typography from '@mui/joy/Typography';
import SvgIcon from '@mui/joy/SvgIcon';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import Tooltip from '@mui/joy/Tooltip';
import Table from '@mui/joy/Table';
import CardWidget from './CardWidget';
import { CardCover } from '@mui/joy';
import ObjectPreview from '@components/objects/ObjectPreview';

export default function TableWidget(props) {
  const LinkComponent = /*view === 'deleted' ? Box :*/ ObjectPreview;

  if(!props.data) {
    return null;
  }

  const data = props.relationship ? (props.data?.[props.relationship] ?? []) : (props.data?.data ?? []);
  const parentData = props.relationship ? props.data : null;

  // console.log(data);

  let title = typeof props.title === 'function' ? props.title(data, parentData) : props.title;

  return (
    <CardWidget unpadded {...props} title={title}>
      {/* <CardOverflow> */}
      <Table
        stickyHeader
        stripe="odd"
        // hoverRow
        sx={{
          margin: 0,
          padding: 0,
        }}
      >
        <thead>
          <tr>
            {props.columns.map(header => <th key={header.label} style={{width: header?.width}}>{header.label}</th>)}
          </tr>
        </thead>
        <tbody>
        {data.length === 0 && (
            <tr>
                <td colSpan={props.columns.length/*+1*/}>
                    <Typography fontSize={'sm'}>There is nothing here yet.</Typography>
                </td>
            </tr>
        )}
        {data.map((row, rowIndex) => {
          const rowClasses = props.columns[0].hasOwnProperty('rowClasses') ? props.columns[0].rowClasses(row, {parentData, LinkComponent}) : '';
          return (
            <tr key={rowIndex} className={rowClasses}>
              {props.columns.map((cell, cellIndex) => {
                const cellClasses = cell.hasOwnProperty('classes') ? cell.classes(row, {parentData, LinkComponent}) : '';
                return (
                  <td key={cellIndex} className={cellClasses}>
                    {/* {cell} */}
                    {cell.cell(row, {parentData, LinkComponent})}
                  </td>
                )
              })}
            </tr>
          )
        })}
        </tbody>
      </Table>
      {/* </CardOverflow> */}

    </CardWidget>
  );
}
